import { mapNewsData, mapTopics } from './news-item-mapper';
import { createAxios } from './caas-api';


const NEWSROOM_TYPES = {
	NEWS: 'news',
	EVENTS: 'events',
	VIDEOS: 'videos',
	SOCIALMEDIAS: 'social_medias',
	GALLERY : 'gallery'
}
Object.freeze(NEWSROOM_TYPES);

const defaultData = { data : { _embedded: { "rh:doc" : [] }}};


const topicSort = { 'formData.tt_value.value' : 1 }
export const sortDesc = {'formData.tt_date' : -1};
export const sortAsc = {'formData.tt_date' : 1};
export const eventFilter = {entityType: NEWSROOM_TYPES.EVENTS}
export const schemaFilter = {schema: 'Newsroom' };

export function getUtcNow() {
	const localeNow = new Date();
	const utcDate = Date.UTC(
		localeNow.getFullYear(),
		localeNow.getMonth(),
		localeNow.getDate(),
		0, 0, 0, 0);
	const utcNow = new Date(utcDate);
	return utcNow;
}

export function defaultEventFilter() {
	const utcNow = getUtcNow();
	return {"$or": [{"formData.tt_date.value":{$gte: utcNow }}, {"formData.tt_end_date.value":{ $gte: utcNow }} ] }

}


export function newsFilters(lng, format) {
	return {
		$or: [
			{
				entityType: NEWSROOM_TYPES.NEWS,
				'locale.identifier': lng,
				'formData.tt_formats.value'  : {
					$elemMatch : {
						identifier: format
					}
				} ,
				'formData.tt_lang_translated.value'  : {
					$elemMatch : {
						identifier: lng
					}
				}
			},
			{
				entityType: NEWSROOM_TYPES.VIDEOS,
				'locale.identifier': lng,
				'formData.tt_lang_translated.value'  : {
					$elemMatch : {
						identifier: lng
					}
				}
			},
			{
				entityType: NEWSROOM_TYPES.SOCIALMEDIAS,
				'locale.identifier': lng,
				'formData.tt_lang_translated.value'  : {
					$elemMatch : {
						identifier: lng
					}
				}
			},
			{
				entityType: NEWSROOM_TYPES.GALLERY,
				'locale.identifier': lng,
				'formData.tt_lang_translated.value'  : {
					$elemMatch : {
						identifier: lng
					}
				}
			}
		]
	}
}
export function eventFilters(stage = undefined, prios = undefined, lng = undefined, translatedlng = undefined, format = undefined) {
	const params = [];

	if (stage) {
		params.push({ categoryType: { $regex: `${stage}` } });
	}

	if (prios) {
		params.push({ "tt_editorial_type.value": { 'identifier': `${prios}` } });
	}

	if (lng) {
		params.push({ "locale.identifier": lng });
	}

	if (translatedlng) {
		params.push({ 'formData.tt_lang_translated.value': { $elemMatch : {identifier: translatedlng }}});
	}

	return params.length > 0 ? {
		$and: params
	} : undefined;

}

export function buildSearchParams(sort, filters = [], page = 1, pageSize = 25) {
	const baseParams = {
		rep: 'hal',
		count: 'true',
		hal: 'f',
		page,
		pagesize: pageSize,
	};
	const params = new URLSearchParams(baseParams);
	params.append('sort', JSON.stringify(sort));
	params.append('filter', JSON.stringify(schemaFilter, `'`));

	for (const filter of filters) {
		if (filter) {
			if (typeof(filter) === 'string' ) {
				params.append('filter', filter);
			} else {
				params.append('filter', JSON.stringify(filter, `'`));
			}
		}
	}

	return params;
}

export function buildUri(document, searchParams) {
	return `${document}/?${searchParams}`;
}


async function getNewsroomDataV3(config, pageSize, thema = NEWSROOM_TYPES.NEWS, stage, lng = 'DE', translatedlng = 'DE', format = 'nr', prios = undefined, eventfilter = undefined) {
	const axios = createAxios(config);
	const { document_v3 : document } = config;
	const page = 1;
	let uri = '';
	if (thema === NEWSROOM_TYPES.NEWS) {
		uri = buildUri(document, buildSearchParams(sortDesc, [newsFilters(lng, format)], page, pageSize));
	} else if (thema === NEWSROOM_TYPES.EVENTS) {
		try {
			const applyFilters =  [ defaultEventFilter(), eventFilter, eventFilters(stage, prios, lng, translatedlng, format)];
			if (eventfilter) {
				applyFilters.push(eventfilter)
			}

			uri = buildUri(document, buildSearchParams(sortAsc, applyFilters, page, pageSize));
		} catch (error) {
			console.error(error);
			return {
				data: []
			}
		}
	}

	return axios.get(uri).catch(_ => defaultData);
}

async function getMediaData(config, newsItemMediaIds, page, pageSize) {
	const mediaMasterParams = new URLSearchParams({
		pagesize: pageSize,
		page
	});
	const or = {
		$or: newsItemMediaIds
	}
	mediaMasterParams.append('filter', JSON.stringify(or));

	const mediaMasterApi = createAxios(config);
	const mediaMasterUri = buildUri(config.mediaMasterDocument, mediaMasterParams);

	const { data: mediaMasterData } = await mediaMasterApi.get(mediaMasterUri).catch(err => []);

	return mediaMasterData;
}

export async function getNewsroomNextPageV3(config, pageLink, pageSize) {
	const axios = createAxios(config);

	function preparePageLink(pageLink) {
		const nextPageQueryString = pageLink.split('?');
		const newLink = `${config.baseURL_v3}/${config.document_v3}?${nextPageQueryString[1]}`;
		return newLink;
	}


	const {data: newsData } = await axios.get(preparePageLink(pageLink)).catch(_ =>  defaultData);
	try {
		console.info(newsData);
		const result = await mapNewsData(newsData, config, pageSize, getMediaData);
		return result;
	} catch (e) {
		console.error(e);
		return defaultData;
	}

}

export async function handleNewsroomV3(config, pageSize, thema = NEWSROOM_TYPES.NEWS, stage, lng = 'DE', translatedlng = 'DE', format = 'nr', 	prios = undefined, eventfilter = undefined) {
	const { data: newsData } = await getNewsroomDataV3(config, pageSize, thema, stage, lng, translatedlng, format, prios, eventfilter);

	try {
		return await mapNewsData(newsData, config, pageSize, getMediaData);
	} catch(e) {
		console.error(e);
		return {
			data: {
				_size: 0,
				_total_pages: 0,
				_returned: 0,
				_links: null,
			}
		};
	}
}

export async function getEventTopics(config, eventfilteritems, lng, page, pageSize) {
	const axios = createAxios(config);
	const { document_v3 : document } = config;
	const uri = buildUri(document, buildSearchParams(topicSort, [
		{$and: [{entityType: 'topics'} ,  {schema: 'Newsroom' },  {'locale.identifier' :  lng   } ] }
	], page, pageSize));

	const response = await axios.get(uri);
	return mapTopics(eventfilteritems, response.data);
}


